import React from 'react';
import imgPetitBateau from './images/boutons/petit-bateau.png';
import imgMerou from './images/boutons/merou.png';
import imgInvertebres from './images/boutons/invertebres.png';
import imgPoissons from './images/boutons/poissons.png';
import imgPoissonHerbiers from './images/boutons/poisson-herbiers.png';
import imgCorb from './images/boutons/corb.png';
import imgDauphin from './images/boutons/dauphin.png';
import imgRorqual from './images/boutons/rorqual.png';
import imgCachalot from './images/boutons/cachalot.png';
// import imgGrosBateau from './images/boutons/gros-bateau.png';
// import imgJetSki from './images/boutons/jet-ski.png';

/* const commentairé = [
	{
		id: 2,
		name: "Gros bateau",
		x: 20,
		y: 67,
		img: imgGrosBateau,
		texte: <></>,
		plusLoin: "",
		son: "13_navire_gros_40s.wav",
	},
	{
		id: 9,
		name: "Jet-ski",
		x: 69,
		y: 27,
		img: imgJetSki,
		texte: <></>,
		plusLoin: "",
		son: "13_jet_ski.wav",
	},
] */

export const donneesSonsMarins = [
	{
		id: 1,
		name: "Mérou",
		x: 25,
		y: 78,
		img: imgMerou,
		portee: 100,
		texte: <>
			<p>Portée d'environ 100&thinsp;m</p>
			<p>Emission dans le cadre de la reproduction en période estivale la nuit</p>
		</>,	
		plusLoin: <>
			<p>Bertucci, F., Lejeune, P., Payrot, J., & Parmentier, E. (2015). Sound production by dusky grouper Epinephelus marginatus at spawning aggregation sites. Journal of Fish Biology, 87(2), 400-421.</p>
			<p>Desiderà, E., Mazzoldi, C., Navone, A., Panzalis, P., Gervaise, C., Guidetti, P., & Iorio, L. D. (2022). Reproductive Behaviours and Potentially Associated Sounds of the Mottled Grouper Mycteroperca rubra: Implications for Conservation. Diversity, 14(5), 318.</p>
		</>,
		son: "03_merou.wav",
	},
	{
		id: 2,
		name: "Petit bateau",
		x: 21,
		y: 55,
		img: imgPetitBateau,
		portee: 2000,
		texte: <>
			<p>Portée d'environ 2000&thinsp;m pour les petites embarcations pour les environnements côtier</p>
			<p>4 composantes&nbsp;:<br/>
			Cavitation de l’hélice, bruit de la machinerie, vague d’étrave, bruit hydrodynamique</p>
		</>,
		plusLoin: <>
			<p>Gervaise, C., Simard, Y., Roy, N., Kinda, B., & Menard, N. (2012). Shipping noise in whale habitat: Characteristics, sources, budget, and impact on belugas in Saguenay–St. Lawrence Marine Park hub. The Journal of the Acoustical Society of America, 132(1), 76-89.</p>
			<p>Simard, Y., Roy, N., Gervaise, C., & Giard, S. (2016). Analysis and modeling of 255 source levels of merchant ships from an acoustic observatory along St. Lawrence Seaway. The Journal of the Acoustical Society of America, 140(3), 2002-2018.</p>
			<p>Magnier, C., & Gervaise, C. (2020). Acoustic and photographic monitoring of coastal maritime traffic: Influence on the soundscape. The Journal of the Acoustical Society of America, 147(6), 3749-3757.</p>
		</>,
		son: "13_navire_petit_60s.wav",
	},
	{
		id: 3,
		name: "Invertébrés",
		x: 29,
		y: 28,
		img: imgInvertebres,
		portee: 1000,
		texte: <>
			<p>Peu mobiles et très nombreux, les invertébrés benthiques émettent, volontairement ou involontairement, des sons formant une biophonie benthique. Les crevettes claqueuses produisent des sons en fermant si rapidement leurs pinces que des bulles de cavitation sont créées et produisent des «&nbsp;mini-explosions&nbsp;» (cf. Figure 2 ). Ces claquements sont suffisamment forts et réguliers pour créer le bruit ambiant des environnements côtiers (Johnson et al, 1947&nbsp;; Au et Bank, 1998&nbsp;; Versluis et al, 2000&nbsp;; Chitre et al, 2012).</p>
			<p>Cependant la biophonie benthique ne se résume pas à la seule contribution des crevettes claqueuses, les oursins créent des sons lors de leur mouvement et lors de la nutrition. Leur lanterne d’Aristote produit un craquement qui est amplifié par le squelette sphérique de l’oursin (Radford et al, 2008). Les décapodes créent des sons lors de leur mouvement, leur nutrition, une communication acoustique est même soupçonnée chez certaines espèces (Popper et al, 2001, Coquereau et al, 2016-a, Jézéquel et al, 2018). La fermeture et l’ouverture des valves des bivalves marins produisent des sons (Di Iorio et al, 2012). Les sons individuels de ces peuplements benthiques se mélangent pour former une biophonie benthique (Coquereau et al, 2016-b).</p>
			<p>Les sons émis par les invertébrés benthiques sont issus de claquement de pinces, de chocs et de mouvements des parties dures du squelette calcaire des invertébrés. Suivant la proximité de l’animal émetteur et la puissance du signal émis, ils se détachent du bruit ambiant et nous pouvons les individualiser. Dans ce cas, ils prennent la forme d’une enveloppe « transitoire » ou « impulsionnelle » concentrant son énergie sur une durée très courte et modulant une porteuse dont la fréquence correspond à la fréquence de vibration naturelle des pièces calcaires s’entrechoquant ou des bulles d’air créées dans l’eau (Clay et Medwin, 1977).</p>
		</>,
		plusLoin: <>
			<p>Gervaise, C., Lossent, J., Valentini-Poirier, C. A., Boissery, P., Noel, C., & Di Iorio, L. (2019). Three-dimensional mapping of the benthic invertebrates biophony with a compact four-hydrophones array. Applied Acoustics, 148, 175-193.</p>
			<p>Coquereau, L., Grall, J., Chauvaud, L., Gervaise, C., Clavier, J., Jolivet, A., & Di Iorio, L. (2016). Sound production and associated behaviours of benthic invertebrates from a coastal habitat in the north-east Atlantic. Marine biology, 163(5), 1-13.</p>
		</>,
		son: "01_Invertebres_sous_marins.mp3",
	},
	{
		id: 4,
		name: "Rorqual commun",
		x: 44,
		y: 38,
		img: imgRorqual,
		texte: <>
			<p>Emissions régulières à 20Hz utilisées probablement pour interagir socialement. Ici le son est accéléré 5 fois pour être audible à l’oreille humaine. Porté de détection estimée à plusieurs dizaines de kilomètres et un chorus de bruit observable jusqu’à des centaines de kilomètres.</p>
			<p>On distingue parmi les mammifères marins émetteurs de sons deux grandes catégories&nbsp;: Les mysticètes (baleine à fanons) et les odontocètes (baleine à dents). Les rorquals communs font parties des mysticètes. On retrouve le rorqual commun plutôt en pleine mer.</p>
		</>,
		son: "rorqual.wav",
	},
	{
		id: 5,
		name: "Poissons",
		x: 49,
		y: 23,
		img: imgPoissons,
		portee: 300,
		texte: <>
			<p>Les poissons émettent volontairement des sons à des fins de communication lors principalement de la reproduction (localisation et sélection des mâles, parades nuptiales synchronisation de l’émission des gamètes), de signalement de présence, d’alerte et de défense de territoire. Devant porter de l’information, la forme des signaux est élaborée et elle permet une détection et une classification. Cependant les portées des sons restent limitées car elles sont adaptées aux distances d’interaction entre poissons variant de quelques mètres à quelques centaines de mètres. Les poissons produisent aussi des sons involontaires lorsqu’ils se nourrissent.</p>
			<p>
				Parmi les 32&nbsp;000 espèces de poissons, au moins 700 ont été identifiées comme productrices de sons. Les poissons produisent des sons de communication par 4 mécanismes différents&nbsp;:
			<ul>
				<li>En faisant vibrer leurs vessies natatoires grâce à des muscles rapides spécialement conçus pour les émissions sonores qui mettent en mouvement des marteaux osseux qui frappent la vessie natatoire&nbsp;;</li>
				<li>
					En faisant vibrer des tendons ou autre organe interne avec des muscles spécialement conçus pour les émissions sonores&nbsp;;
					par relâchement de gaz contenu dans la vessie natatoire&nbsp;;
				</li>
				<li>La stridulation en faisant vibrer leurs dents, deux os les uns sur les autres ou les aiguilles des nageoires.</li>
			</ul>
			</p>
			<p>Les productions sonores par vibration des vessies natatoires et stridulation des tendons sont les plus fréquentes et sont celles qui produisent les plus grands niveaux sonores. </p>
			<p>Sauf cas particulier, la production sonore des poissons suit un pattern commun&nbsp;: un excitateur (muscle) vient mettre en vibration un résonateur (vessie natatoire, tendon, os) et ceci plusieurs fois consécutivement. Les sons émis apparaissent ainsi constitués d’une enveloppe rassemblant plusieurs impulsions modulées par un cosinus. Le nombre d’impulsions et leur rythme de répétition dépendent des capacités de mise en action du muscle excitateur. La fréquence de résonnance dépend de la taille du résonateur (tendon, vessie). Les sons sonnent comme un bruit de tambour pour les rythmes les plus lents et comme des «&nbsp;signaux de grenouilles&nbsp;» pour les rythmes les plus rapides.</p>
		</>,
		plusLoin: <>
			<p>AMORIM, M. Clara P. Diversity of sound production in fish. Communication in fishes, 2006, vol. 1, p. 71-104.</p>
		</>,
		son: "07_famiille09_poisson_5s.wav",
	},
	{
		id: 6,
		name: "Cachalot",
		x: 55,
		y: 43,
		img: imgCachalot,
		texte: <>
			<p>Émissions régulières à 20Hz utilisées probablement pour interagir socialement. Ici le son est accéléré 5 fois pour être audible à l’oreille humaine. Porté de détection estimée à plusieurs dizaines de kilomètres et un chorus de bruit observable jusqu’à des centaines de kilomètres.</p>
			<p>On distingue parmi les mammifères marins émetteurs de sons deux grandes catégories&nbsp;: Les mysticètes (baleine à fanons) et les odontocètes (baleine à dents). Les cachalots font parties des odontocètes. De nombreux cachalots profite d’un habitat propice sur les tombants entre le plateau continental et la pleine océanique.</p>
		</>,
		son: "cachalot.wav",
	},
	{
		id: 7,
		name: "Poisson des Herbiers",
		x: 60,
		y: 29,
		img: imgPoissonHerbiers,
		portee: "300 à 1200",
		texte: <>
			Portée d’un son individuel ≈ 300 m, portée du chorus ≈ 1200 m
			Emission dans le cadre en période estivale la nuit, par les rascasses, indicateurs de l’état de santé des herbiers.
		</>,
		plusLoin: <>
			<p>Di Iorio, L., Raick, X., Parmentier, E., Boissery, P., Valentini‐Poirier, C. A., & Gervaise, C. (2018). ‘Posidonia meadows calling’: a ubiquitous fish sound with monitoring potential. Remote Sensing in Ecology and Conservation, 4(3), 248-263.</p>
			<p>Bolgan, M., Soulard, J., Di Iorio, L., Gervaise, C., Lejeune, P., Gobert, S., & Parmentier, E. (2019). Sea chordophones make the mysterious/Kwa/sound: identification of the emitter of the dominant fish sound in Mediterranean seagrass meadows. Journal of Experimental Biology, 222(11), jeb196931.</p>
		</>,
		son: "08_herbier_prado_60s.wav",
	},
	{
		id: 8,
		name: "Corb",
		x: 78,
		y: 34,
		img: imgCorb,
		portee: 300,
		texte: <>
			<p>Emission dans le cadre de la reproduction en période estivale la nuit.</p>
		</>,
		plusLoin: <>
			<p>Parmentier, E., Di Iorio, L., Picciulin, M., Malavasi, S., Lagardère, J. P., & Bertucci, F. (2018). Consistency of spatiotemporal sound features supports the use of passive acoustics for long‐term monitoring. Animal Conservation, 21(3), 211-220.</p>
			<p>Di Iorio, L., Bonhomme, P., Michez, N., Ferrari, B., Gigou, A., Panzalis, P., … & Gervaise, C. (2020). Spatio-temporal surveys of the brown meagre Sciaena umbra using passive acoustics for management and conservation. BioRxiv.</p>
		</>,
		son: "02_Corb.wav",
	},
	{
		id: 9,
		name: "Grand dauphin",
		x: 90,
		y: 41,
		img: imgDauphin,
		portee: 1000,
		texte: <>
			<p>2 composantes&nbsp;: sifflements pour la communication, clics sonar pour la géolocalisation et la chasse.</p>
			<p>Les émissions sonores des grands dauphins se décomposent en deux familles (Au, 1993)&nbsp;: les signaux dédiés aux interactions sociales et les signaux dédiés à la géolocalisation des obstacles ou des proies.</p>
			<p>Les signaux dédiés aux interactions sociales sont communément appelés «&nbsp;sifflements&nbsp;» ou «&nbsp;vocalisations&nbsp;», ils se présentent sous la forme de signaux à modulation de fréquence peu directionnelle (May-Collado et Wartzok, 2008). Les fréquences émises sont comprises entre 3 kHz et 15 kHz, d’une durée de l’ordre de 0.5 seconde. La loi de fréquence instantanée présente des marches d’escaliers caractéristiques des grands dauphins au regard des autres espèces de delphinidés . Elle permet ainsi la reconnaissance de l’espèce voire des individus (Bazua-Duran, 2004 ; Janik et al, 2006). Le niveau sonore des sifflements est 158+-1 dB re.1µPa@1m correspondant à un espace de communication entre individus compris entre 1 km et 4 km (Janik, 1999).</p>
			<p>Les signaux dédiés à la géolocalisation des obstacles ou des proies sont communément appelés «&nbsp;clics d’écholocalisation&nbsp;». Ils s’organisent en une succession de signaux très courts (8-72 µs, Wahlberg et al, 2011) directionnels (cône d’émission de 7°, Au, 1993) nommés impulsions ou clics (Au, 1993). La succession est appelée «&nbsp;train de clics&nbsp;». Au sein d’un même train les dates d’émissions ne sont pas réparties aléatoirement mais organisées soit avec un intervalle constant entre clics (ICI&nbsp;: Inter Click Interval, ICI compris entre 0.0005 s et 0.1s) cet intervalle dépendant de la distance de recherche des proies ou des obstacles ou soit avec un intervalle entre clics s’accélérant lorsque le dauphin approche d’un obstacle ou d’une proie. Au maximum du taux de répétition des clics, le train de clic sont appelés buzz et caractérise souvent les instants précédents une tentative de captures de proies. La fréquence pic des clics varie suivant l’angle de captation par rapport à l’angle d’émissions, elle est comprise entre 30 kHz et 60 kHz pour les clics ‘off-axis’ (mesurés en dehors du cône d’émission) et peut atteindre 120 kHz pour les clics ‘on-axis’ (mesurés dans le cône d’émission). Leur bande-passante varie entre 23 et 54 kHz (Wahlberg et al, 2011). Les niveaux sonores émis sont 177+-7 dB re.1µPa peak-peak @1m pour les clics off-axis et peuvent s’élever jusqu’à 228 dB re. 1µPa peak-peak @1m pour les clics on-axis (Wahlberg et al, 2011).</p>
		</>,
		plusLoin: <>
			<p>Au, W. W. (1993). The sonar of dolphins. Springer Science & Business Media.</p>
			<p>Jones, B., Zapetis, M., Samuelson, M. M., & Ridgway, S. (2020). Sounds produced by bottlenose dolphins (Tursiops): A review of the defining characteristics and acoustic criteria of the dolphin vocal repertoire. Bioacoustics, 29(4), 399-440.</p>
		</>,
		son: 'dauphins.wav',// TMP
	},
	
]